import { Flex, Text } from "@fluentui/react-northstar";
import { CheckmarkCircleRegular, DismissCircleRegular } from "@fluentui/react-icons";
import styled from "styled-components";

const AlertSuccess = ({ status = "APPROVE" }) => {
    const isApproved = status === "APPROVE";

    const title = isApproved
        ? "La note de frais a bien été validée"
        : "La note de frais a bien été refusée";

    return (
        <Wrapper column hAlign="center" vAlign="center" gap="gap.medium">
            <IconWrapper hAlign="center" vAlign="center" approved={isApproved}>
                {isApproved ? (
                    <CheckmarkCircleRegular fontSize={28} />
                ) : (
                    <DismissCircleRegular fontSize={28} />
                )}
            </IconWrapper>
            <Flex column hAlign="center" gap="gap.smaller">
                <Title>{title}</Title>
                <Description>Vous pouvez fermer cet onglet.</Description>
            </Flex>
        </Wrapper>
    );
};

export default AlertSuccess;

const Wrapper = styled(Flex)`
    width: 100%;
    padding: 64px 24px;
`;

const IconWrapper = styled(Flex)`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: ${({ approved }) => (approved ? "#f1faf1" : "#fdf3f4")};
    color: ${({ approved }) =>
        approved ? "var(--color-success)" : "var(--color-danger)"};
`;

const Title = styled(Text)`
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: #242424;
`;

const Description = styled(Text)`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #616161;
    text-align: center;
    max-width: 360px;
`;
